module.exports = __webpack_public_path__ + "img/65_3.c3d2cbe3.png";